import React from 'react';
import { useSelector } from 'react-redux';
import { AccountTitle, SetName, Status, StatusText } from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileView.styled';
import { ImageBox } from 'src/pages/consignmentAdd/components/submit/ShippingDetails.styled';
import { ImageContainer } from 'src/pages/consignmentAdd/components/cart/productGuide/ProductGuide.styled';
import DownArrowBlue from 'src/assets/images/DownArrowBlue.svg';

const CondensedMobileViewHeader = ({
    isEquityTemplate,
    countryISOCode,
    isBundlesChildren,
    productCFN,
    cfn,
    bom,
    isCartScreenOrProductGuide,
    isExpanded,
    isOrderScreen,
    expandedCard,
    onToggle,
    productKey,
    setExpandedCard,
    setBundleChildrenFlag,
    onSetItemClick,
    setOrItemDetails,
    setNameColor,
    clickable,
    setNameFontSizeDesktop,
    setNameFontSizeMobile,
    setNameLetterSpacing,
    enableTemplateCardSpecificStyling,
    isFixedWidth,
    winWidth,
    reviewPage,
    priceOverridePage,
    isShippingScreen,
    isSetDetailPage,
    isconsignmentAddOrder,
    salesOrg,
    uom,
    type,
    isQuickOrder
}) => {
    const isLanguageChanged = useSelector(
            (state) => state.loginReducer.isLanguageChanged
        );
    // runtime sanity check to catch invalid imports that cause React to throw
    if (process.env.NODE_ENV !== 'production') {
        try {
            const missing = [];
            if (typeof AccountTitle === 'undefined') missing.push('AccountTitle');
            if (typeof ImageBox === 'undefined') missing.push('ImageBox');
            if (typeof ImageContainer === 'undefined') missing.push('ImageContainer');
            if (typeof SetName === 'undefined') missing.push('SetName');
            if (typeof Status === 'undefined') missing.push('Status');
            if (typeof StatusText === 'undefined') missing.push('StatusText');
            if (missing.length) {
                // log detailed info to help reproduce
                // eslint-disable-next-line no-console
                console.error('CondensedMobileViewHeader: missing imports ->', missing);
                return null;
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('CondensedMobileViewHeader: error during import check', e);
        }
    }
    return (
        <>
        <AccountTitle
            marginTop={'0px'}
            marginLeft={'0px'}
            isLanguageChange={isLanguageChanged}
            isEquityTemplate={isEquityTemplate}
            isUSUser={countryISOCode === 'US'}
        >
            {!isBundlesChildren && (
                <ImageBox
                    border={'1px solid #ebebeb'}
                    borderRadius={'8px'}
                    backgroundColor={'transparent'}
                    boxShadow={'0px 0px 2px #00000029'}
                >
                    <ImageContainer
                        id={`down-arrow-blue-${productCFN || cfn || bom
                            }`}
                        src={DownArrowBlue}
                        alt="down-arrow"
                        isExpanded={
                            isCartScreenOrProductGuide
                                ? isExpanded
                                : isOrderScreen
                                    ? isExpanded
                                    : expandedCard
                        }
                        onClick={

                            isCartScreenOrProductGuide
                                ? () => onToggle(productKey)
                                : isOrderScreen
                                    ? () => onToggle(cfn || bom)
                                    : () => {
                                        setExpandedCard(
                                            !expandedCard
                                        );
                                        setBundleChildrenFlag(
                                            !expandedCard
                                                ? productKey || cfn
                                                : ''
                                        );
                                    }
                        }
                        style={{
                            marginLeft: '10px',
                            display: 'flex',
                            marginRight: '10px',
                        }}
                    />
                </ImageBox>
            )}
            <SetName
                onClick={() => {
                    onSetItemClick(setOrItemDetails);
                }}
                isQuickOrder= {isQuickOrder}
                color={setNameColor}
                clickable={clickable}
                fontSizeDesktop={setNameFontSizeDesktop}
                fontSizeMobile={setNameFontSizeMobile}
                setNameLetterSpacing={setNameLetterSpacing}
                enableTemplateCardSpecificStyling={
                    enableTemplateCardSpecificStyling
                }
                id={`add-cart-btn-${productCFN || cfn || bom}`}
                style={{
                    width:
                        isFixedWidth & (winWidth < 390)
                            ? '10ch'
                            : isFixedWidth & (winWidth >= 390)
                                ? '11ch'
                                : reviewPage || priceOverridePage
                                    ? '100%'
                                    : isShippingScreen ||
                                        isSetDetailPage
                                        ? '11ch'
                                        : 'auto',
                    minWidth: isFixedWidth ? '10ch' : 'auto',
                    maxWidth: isFixedWidth ? '11ch' : 'none',
                    display: 'flex',
                    marginLeft: '10px',
                    marginTop: '3px',
                    whiteSpace: 'nowrap',
                    pointerEvents: isQuickOrder ? 'none' : 'auto',
                }}
            >
                {productCFN || cfn || bom}{' '}
                {isconsignmentAddOrder ? (
                    salesOrg == 'S030' ? (
                        <div
                            style={{
                                display: 'flex',
                                marginLeft: '100px',
                            }}
                        >
                            <Status
                                style={{ marginTop: '3px' }}
                            >
                                <StatusText>
                                    {uom || type}
                                </StatusText>
                            </Status>
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                marginLeft: '50px',
                            }}
                        >
                            <Status
                                style={{ marginTop: '3px' }}
                            >
                                <StatusText>
                                    {uom || type}
                                </StatusText>
                            </Status>
                        </div>
                    )
                ) : null}
            </SetName>
        </AccountTitle>
        </>
    );
};

export default CondensedMobileViewHeader;